import React from 'react'
import { useSelector } from 'react-redux'
import FullContainerWidth from '../../components/abstractObjects/FullContainerWidth'
import { selectVarById } from '../var/varSlice'
import { Grid } from '@material-ui/core'
import { BasicLabel } from '../../components/abstractObjects/Label'

export const ReferBackHistory = ({ varId }) => {
    const varx = useSelector((state) => selectVarById(state, varId))
    if (varx.VarUnapprovals.length == 0) return [(<FullContainerWidth key="1"><p><BasicLabel text="NO_REFER_BACK_PROVIDED" /></p></FullContainerWidth>), null]
    var c = 0
    var referBackHistory = varx.VarUnapprovals.map((object) => (
        <Grid container align="center" justifyContent="center" style={{ color: "#17a2b8", borderBottom: '1px solid #ddd', marginTop: '1rem', paddingBottom: '0.5rem' }} key={c++}>
            <Grid item xs={6}><h3><p>{object.AspNetUser.Name} {object.AspNetUserId === varx.SupervisorId ? <BasicLabel text="SUPERVISOR_BRACKETS" /> : object.AspNetUserId === varx.ContactId ? <BasicLabel text="INSPECTOR_BRACKETS" /> : <BasicLabel text="SD_BRACKETS" />}</p></h3></Grid>
            <Grid item xs={6}>{object.CreatedDate !== null ? (object.CreatedDate.substring(0, 10).split("-").reverse().join("/") + " " + object.CreatedDate.substring(11)) : ""}</Grid>
            <Grid item xs={12}>{object.Comment}</Grid>
        </Grid>
    ))
    return [referBackHistory, null]
}

export default ReferBackHistory